import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import { ComboBox } from '../../../../../../shared/components/form-components/autocomplete-components/ComboBox/ComboBox';
import { ModeAwareInput } from '../../../../../../shared/components/form-components';
import { FormFieldsGrid } from '../../../FormFieldsGrid/FormFieldsGrid';
import { getTimezoneOptions } from '../../../../../../shared/utils/timezoneUtils/getTimezoneOptions';
import { Mode } from '../../../../../../general-types';

import classes from './TimezoneSection.module.scss';
import { ChallengeFormValues } from '../../../../../interfaces/ChallengeFormValues';

type TimezoneSectionProps = {
  mode: Mode;
};

export const TimezoneSection = ({ mode }: TimezoneSectionProps) => {
  const { control } = useFormContext<ChallengeFormValues>();

  const timezoneOptions = useMemo(() => getTimezoneOptions(), []);

  return (
    <FormFieldsGrid mode={mode}>
      <TitleWithDescription
        title="Timezone"
        titleFont="body-14-bold"
        description="The time zone in which the challenge takes place."
      />
      <div className={classes.span2Columns}>
        <ModeAwareInput
          mode={mode}
          control={control}
          name="importantDates.timeZone"
          label="Timezone"
          options={timezoneOptions}
          renderEdit={(props) => (
            <ComboBox
              {...props}
              size="small"
              variant="standard"
              rules={{ required: 'Timezone is required' }}
            />
          )}
        />
      </div>
    </FormFieldsGrid>
  );
};
